
export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
    , detectIpad: IPADDETECTED
    , isResponsive: false
    , allEventsLink: true
    , allEventsLinkText: 'view ALL events'
    , hasImages: false
    , imageBackground: false
    , lazyLoadImages: true
    , buyNowButton: { visible: false, text: 'BUY NOW' }
    , moreButton: { visible: false, text: 'MORE' }
    , maxItemsVisible: 4
    , hasDescription: false
    , textContainer: true
    , link: 'all'
    , attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons'
    }
    , multiFeatureLoaded: function (data) {

      let eventsQuantity = data.length;
      $('#multiScheduleFeature').prepend('<div class="events-title"><h2>Upcoming Events</h2></div>');

      $(`#${widgetName} .featureItem`).each(function (i) {
        let widgetDate = data[i].Date;
        let widgetName = data[i].Name;
        let widgetURL = data[i].URL;
        let widgetDescription = data[i].Description;

        let fixedDate = widgetDate.split('-');

        let dayStart;
        let monthStart;
        let dayEnd;
        let monthEnd;
        let dateLayout;

        switch (fixedDate.length) {
          case 1:
            dayStart = formatDate(fixedDate, 0, 0, 1);
            monthStart = formatDate(fixedDate, 0, 0, 0);
            dateLayout = buildEventDateLayout(monthStart, dayStart);
            break;

          case 2:
            monthStart = formatDate(fixedDate, 0, 0, 0);
            dayStart = formatDate(fixedDate, 0, 0, 1);
            monthEnd = formatDate(fixedDate, 1, 0, 0);
            dayEnd = formatDate(fixedDate, 1, 0, 1);
            dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
            break;

          default:
            break;
        }

        $(this).empty();
        $(this).append(dateLayout);
        $(this).append(buildEventInfoLayout(widgetName, widgetDescription));
        $('.all-events-btn').addClass('button');
        $('.all-events-btn').removeClass('all-events-btn');

        if (widgetURL == "") {
          $(this).removeAttr('href');
          $(this).addClass('void');
        }
      });


      if (eventsQuantity == 0) {
        $('#seoBlock').addClass('no-events');
        $(`#${widgetName}`).remove();
      }
    }
  });
};





function buildEventInfoLayout(title, description) {
  let infoLayout = `
    <div class="event-info">
      <span class="event-name">${title}</span>
      <span class="event-description">${description}</span>
    </div>`

  if (description == "") {
    infoLayout = `
    <div class="event-info">
      <span class="event-name">${title}</span>
    </div>`
  }
  return infoLayout;
}

function formatDate(date, slot1, slot2, slot3) {
  let splittedDate = ((date[slot1].trim()).split(',')[slot2].trim()).split(' ')[slot3].trim();
  return splittedDate;
}

function buildEventDateLayout(eventStartMonth, eventStartDay, eventEndMonth = null, eventEndDay = null) {
  let dateLayout;
  if (eventEndMonth === null || eventEndDay === null) {
    dateLayout = `
          <div class="event-date">
              <span class="month">${eventStartMonth}</span>
              <span class="day">${eventStartDay}</span>
          </div>`;

  } else if (eventStartMonth == eventEndMonth) {
    dateLayout = `
          <div class="event-date">
              <span class="month">${eventStartMonth}</span>
              <span class="day">${eventStartDay}<span class="separator">-</span>${eventEndDay}</span>
          </div>`;

  } else {
    dateLayout = `
          <div class="event-date date-range">
              <div class="combo-date">
                  <span class="month">${eventStartMonth}</span>
                  <span class="day">${eventStartDay}</span>
              </div>
               <span class="separator-month">-</span>
              <div class="combo-date">
                  <span class="month">${eventEndMonth}</span>
                  <span class="day">${eventEndDay}</span>
              </div>
          </div>`;
  }
  return dateLayout;
}

